'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.buildAPIInstance = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _utils = require('./utils');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright(c) 2018, DeCurtis Corporation.All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * File name: api.js
 * Author   : DeCurtis Team
 * Creation Date: 27/9/18 7: 27 PM
 *
 */

// calls all apis for ya

var TYPE_JSON = 'application/json';

var buildAPIInstance = exports.buildAPIInstance = function buildAPIInstance(_ref) {
	var url = _ref.url,
	    authorization = _ref.authorization,
	    _ref$contenttype = _ref.contenttype,
	    contenttype = _ref$contenttype === undefined ? TYPE_JSON : _ref$contenttype,
	    errorLog = _ref.errorLog,
	    transformRequest = _ref.transformRequest,
	    biometricEnabled = _ref.biometricEnabled,
	    vvUserAgent = _ref.vvUserAgent;

	var correlationId = (0, _v2.default)();
	// wait for valid base url
	var objAxios = _axios2.default.create({
		baseURL: url,
		headers: {
			Authorization: authorization,
			"Biometric-Enabled": biometricEnabled,
			'Accept-Language': '', // TODO: auto pass language for error messages
			common: (0, _defineProperty3.default)({
				Accept: TYPE_JSON,
				'Content-Type': contenttype,
				CorrelationId: correlationId
			}, _constants2.default.vvUserAgentHeader, vvUserAgent),
			post: {
				'Content-Type': TYPE_JSON
			}
		}
	});

	// only add transformRequest if required
	if (!(0, _isEmpty2.default)(transformRequest)) {
		objAxios.defaults.transformRequest = transformRequest;
	}

	// lof request errors
	objAxios.interceptors.request.use(function (_config) {
		(0, _utils.logRequest)(_config, errorLog);
		return _config;
	}, function (error) {
		(0, _utils.logRequestError)(error, errorLog);
		return _promise2.default.reject(error);
	});

	// log response errors
	objAxios.interceptors.response.use(function (response) {
		(0, _utils.logResponse)(response, errorLog);
		return response;
	}, function (error) {
		// get the original request
		var originalRequest = error.config;

		// https://github.com/axios/axios/issues/934#issuecomment-322003342
		if (error && error.response && error.response.status === 400 && originalRequest && !originalRequest.retry && error.response.data && error.response.data.message && error.response.data.message === _constants2.default.expiredTokenMessage) {
			originalRequest.retry = true;
			// if it is the client token then call that api
			if (_index2.default.config.clientToken === authorization) {
				return _index2.default.refreshClientToken().then(function () {
					// replace the original with the new auth
					originalRequest.headers.Authorization = _index2.default.config.clientToken;
					return objAxios.request(originalRequest);
				}).catch(function (err) {
					throw err;
				});
			} else if (_index2.default.isRefreshUserTokenRequired) {
				return _index2.default.refreshUserToken().then(function (_ref2) {
					var tokenType = _ref2.tokenType,
					    accessToken = _ref2.accessToken;

					// replace the original with the new auth
					originalRequest.headers.Authorization = tokenType + ' ' + accessToken;
					return objAxios.request(originalRequest);
				}).catch(function (err) {
					throw err;
				});
			}
		}

		// log it now
		(0, _utils.logResponseError)(error, errorLog);
		return _promise2.default.reject(error);
	});

	return objAxios;
};

var api = function api(params) {
	return buildAPIInstance(params);
};

exports.default = api;
//# sourceMappingURL=api.js.map